import styled from 'styled-components';
import { Switch as BaseSwitch } from '@salutejs/plasma-core';
import { accent, surfaceLiquid03, white } from '@salutejs/plasma-tokens';
import { spatnavClassNameAttrs } from '../../utils';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Switch/Switch');

/**
 * Визуальный переключатель между двумя взаимоисключающими состояниями — вкл. и выкл.
 */
export var Switch = /*#__PURE__*/styled(BaseSwitch).attrs(spatnavClassNameAttrs).withConfig({
  componentId: "plasma-ui__sc-1xo0pzo-0"
})(["--plasma-switch-trigger-background:", ";--plasma-switch-trigger-background-checked:", ";--plasma-switch-ellipse-background:", ";"], surfaceLiquid03, accent, white);